import React from 'react';
import { Shield, CheckCircle2, Database, Building2, FileText } from 'lucide-react';
export function CapabilityStatement() {
  return <section id="statement" className="py-12 bg-white print:py-0" data-id="element-18">
      <div className="max-w-7xl mx-auto px-4 md:px-8" data-id="element-19">
        <div className="bg-slate-50 border border-slate-200 p-8 md:p-16 shadow-inner relative overflow-hidden print:shadow-none print:border-none print:p-0" data-id="element-20">
          {/* Print Header */}
          <div className="flex flex-col md:flex-row justify-between items-start gap-8 mb-16 border-b border-slate-300 pb-12 print:mb-8" data-id="element-21">
            <div data-id="element-22">
              <div className="flex items-center gap-3 mb-4" data-id="element-23">
                <div className="w-14 h-12 flex items-center justify-center overflow-hidden" data-id="element-24">
                  <img src="https://cdn.magicpatterns.com/uploads/qpgdNqUL4qY23U6JmdRkbZ/Codes_and_cogs_(1).png" alt="Codes & Cogs Logo" className="h-full w-auto object-contain" data-id="element-25" />
                </div>
                <div className="flex flex-col leading-tight" data-id="element-26">
                  <span className="text-federal-blue font-black text-3xl tracking-tighter uppercase" data-id="element-27">
                    Codes & Cogs
                  </span>
                  <span className="text-tech-slate text-xs font-bold tracking-[0.2em] uppercase" data-id="element-28">
                    Digital Capability Statement
                  </span>
                </div>
              </div>
              <p className="text-tech-slate font-medium max-w-md" data-id="element-29">
                Providing mission-critical digital and physical infrastructure
                solutions for Federal and State agencies.
              </p>
            </div>

            <div className="bg-white p-6 border border-slate-200 rounded shadow-sm min-w-[280px] print:shadow-none" data-id="element-30">
              <h4 className="text-federal-blue font-black text-xs uppercase tracking-widest mb-4 border-b border-slate-100 pb-2" data-id="element-31">
                Entity Data
              </h4>
              <div className="space-y-3" data-id="element-32">
                <div className="flex justify-between text-xs" data-id="element-33">
                  <span className="font-bold text-tech-slate uppercase" data-id="element-34">
                    UEI:
                  </span>
                  <span className="font-mono text-federal-blue" data-id="element-35">
                    ZK82N9L1M4P7
                  </span>
                </div>
                <div className="flex justify-between text-xs" data-id="element-36">
                  <span className="font-bold text-tech-slate uppercase" data-id="element-37">
                    CAGE:
                  </span>
                  <span className="font-mono text-federal-blue" data-id="element-38">9XYL4</span>
                </div>
                <div className="flex justify-between text-xs" data-id="element-39">
                  <span className="font-bold text-tech-slate uppercase" data-id="element-40">
                    Status:
                  </span>
                  <span className="text-muted-gold font-bold uppercase" data-id="element-41">
                    WOSB / EDWOSB
                  </span>
                </div>
                <div className="pt-2 border-t border-slate-100" data-id="element-42">
                  <span className="font-bold text-tech-slate uppercase text-[10px]" data-id="element-43">
                    Primary NAICS:
                  </span>
                  <div className="flex flex-wrap gap-2 mt-2" data-id="element-44">
                    {['541511', '541512', '561621', '423430'].map(code => <span key={code} className="bg-slate-100 px-2 py-1 rounded text-[10px] font-bold text-tech-slate" data-id="element-45">
                        {code}
                      </span>)}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="grid lg:grid-cols-3 gap-12" data-id="element-46">
            <div className="lg:col-span-2 space-y-12" data-id="element-47">
              <div data-id="element-48">
                <h3 className="text-federal-blue font-black text-lg uppercase tracking-widest mb-6 flex items-center gap-2" data-id="element-49">
                  <Shield className="w-5 h-5 text-muted-gold" data-id="element-50" />
                  Core Competencies
                </h3>
                <div className="grid sm:grid-cols-2 gap-6" data-id="element-51">
                  <div className="space-y-3" data-id="element-52">
                    <div className="flex items-start gap-3" data-id="element-53">
                      <CheckCircle2 className="w-4 h-4 text-muted-gold mt-1 flex-shrink-0" data-id="element-54" />
                      <p className="text-sm text-tech-slate font-medium" data-id="element-55">
                        Custom Software & Mobile App Dev
                      </p>
                    </div>
                    <div className="flex items-start gap-3" data-id="element-56">
                      <CheckCircle2 className="w-4 h-4 text-muted-gold mt-1 flex-shrink-0" data-id="element-57" />
                      <p className="text-sm text-tech-slate font-medium" data-id="element-58">
                        Section 508 & WCAG 2.1 Compliance
                      </p>
                    </div>
                    <div className="flex items-start gap-3" data-id="element-59">
                      <CheckCircle2 className="w-4 h-4 text-muted-gold mt-1 flex-shrink-0" data-id="element-60" />
                      <p className="text-sm text-tech-slate font-medium" data-id="element-61">
                        NIST 800-171/53 Security Audits
                      </p>
                    </div>
                  </div>
                  <div className="space-y-3" data-id="element-62">
                    <div className="flex items-start gap-3" data-id="element-63">
                      <CheckCircle2 className="w-4 h-4 text-muted-gold mt-1 flex-shrink-0" data-id="element-64" />
                      <p className="text-sm text-tech-slate font-medium" data-id="element-65">
                        Physical Security & Access Control
                      </p>
                    </div>
                    <div className="flex items-start gap-3" data-id="element-66">
                      <CheckCircle2 className="w-4 h-4 text-muted-gold mt-1 flex-shrink-0" data-id="element-67" />
                      <p className="text-sm text-tech-slate font-medium" data-id="element-68">
                        IT Supply Chain & Logistics
                      </p>
                    </div>
                    <div className="flex items-start gap-3" data-id="element-69">
                      <CheckCircle2 className="w-4 h-4 text-muted-gold mt-1 flex-shrink-0" data-id="element-70" />
                      <p className="text-sm text-tech-slate font-medium" data-id="element-71">
                        Healthcare IT (HIPAA Compliant)
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div data-id="element-72">
                <h3 className="text-federal-blue font-black text-lg uppercase tracking-widest mb-6 flex items-center gap-2" data-id="element-73">
                  <Database className="w-5 h-5 text-muted-gold" data-id="element-74" />
                  Past Performance
                </h3>
                <div className="space-y-4" data-id="element-75">
                  <div className="p-4 bg-white border-l-4 border-federal-blue shadow-sm print:shadow-none" data-id="element-76">
                    <h4 className="font-bold text-federal-blue text-sm" data-id="element-77">
                      Department of Health & Human Services
                    </h4>
                    <p className="text-xs text-tech-slate mt-1" data-id="element-78">
                      Modernization of HIPAA-compliant data portals for regional
                      field offices.
                    </p>
                  </div>
                  <div className="p-4 bg-white border-l-4 border-federal-blue shadow-sm print:shadow-none" data-id="element-79">
                    <h4 className="font-bold text-federal-blue text-sm" data-id="element-80">
                      GSA / Public Buildings Service
                    </h4>
                    <p className="text-xs text-tech-slate mt-1" data-id="element-81">
                      Installation of commercial-grade surveillance and access
                      control systems.
                    </p>
                  </div>
                  <div className="p-4 bg-white border-l-4 border-federal-blue shadow-sm print:shadow-none" data-id="element-82">
                    <h4 className="font-bold text-federal-blue text-sm" data-id="element-83">
                      State of Maryland - Dept of IT
                    </h4>
                    <p className="text-xs text-tech-slate mt-1" data-id="element-84">
                      WCAG 2.1 AA accessibility remediation for citizen-facing
                      portals.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="space-y-8" data-id="element-85">
              <div className="bg-federal-blue text-white p-8 rounded-sm print:bg-slate-100 print:text-tech-slate" data-id="element-86">
                <h3 className="font-black text-sm uppercase tracking-[0.2em] mb-6 flex items-center gap-2" data-id="element-87">
                  <Building2 className="w-4 h-4 text-muted-gold" data-id="element-88" />
                  Company Info
                </h3>
                <div className="space-y-4 text-sm" data-id="element-89">
                  <div data-id="element-90">
                    <p className="font-bold opacity-60 uppercase text-[10px]" data-id="element-91">
                      Established
                    </p>
                    <p data-id="element-92">2011 (15 Years Experience)</p>
                  </div>
                  <div data-id="element-93">
                    <p className="font-bold opacity-60 uppercase text-[10px]" data-id="element-94">
                      Headquarters
                    </p>
                    <p data-id="element-95">Charlotte, NC</p>
                  </div>
                  <div data-id="element-96">
                    <p className="font-bold opacity-60 uppercase text-[10px]" data-id="element-97">
                      Regional Office
                    </p>
                    <p data-id="element-98">Baltimore, MD</p>
                  </div>
                  <div data-id="element-99">
                    <p className="font-bold opacity-60 uppercase text-[10px]" data-id="element-100">
                      Contact
                    </p>
                    <p data-id="element-101">gov@codesandcogs.com</p>
                  </div>
                </div>
              </div>

              <div className="border-2 border-dashed border-slate-300 p-6 rounded-sm text-center print:hidden" data-id="element-102">
                <FileText className="w-8 h-8 text-slate-300 mx-auto mb-4" data-id="element-103" />
                <p className="text-xs font-bold text-tech-slate uppercase tracking-wider mb-4" data-id="element-104">
                  Print-Ready View
                </p>
                <button className="text-federal-blue font-bold text-sm hover:underline" onClick={() => window.print()} data-id="element-105">
                  Open Print Dialog
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}